exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "fieldset {\n}\n.item {\n  display: block;\n}\nlabel {\n  display: inline;\n}\ninput[type=checkbox] {\n  display: inline;\n}\n", "", {"version":3,"sources":["/home/cubo/pospimus/client/app/pimus/pimus.css"],"names":[],"mappings":"AAAA;CACC;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB","file":"pimus.css","sourcesContent":["fieldset {\n}\n.item {\n  display: block;\n}\nlabel {\n  display: inline;\n}\ninput[type=checkbox] {\n  display: inline;\n}\n"],"sourceRoot":""}]);

// exports
